module.exports = __webpack_public_path__ + "img/biank2.8769e39d.png";